var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerIcnTc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "owner-icn-tc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop---dtc-confirm-car-[edit]-copy",
    transform: "translate(-384.000000, -1254.000000)",
    fill: "#36CECE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-molecules/summary-page/driver-details",
    transform: "translate(244.000000, 1230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "summary"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title-row",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/summary/title-row"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/icons/32/summary/tc/user",
    transform: "translate(140.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.16129032,0 0,7.16129032 0,16 C0,24.8387097 7.16129032,32 16,32 C24.8387097,32 32,24.8387097 32,16 C32,7.16129032 24.8387097,0 16,0 Z M16,6.19354839 C19.1355521,6.19354839 21.6774194,8.73541561 21.6774194,11.8709677 C21.6774194,15.0065199 19.1355521,17.5483871 16,17.5483871 C12.8644479,17.5483871 10.3225806,15.0065199 10.3225806,11.8709677 C10.3225806,8.73541561 12.8644479,6.19354839 16,6.19354839 Z M16,28.3870968 C12.3548362,28.3856611 8.89612284,26.7755297 6.5483871,23.9870968 C7.76129032,21.7032258 10.1354839,20.1290323 12.9032258,20.1290323 C13.0585523,20.1302915 13.2128647,20.154199 13.3612903,20.2 C15.0703647,20.7935389 16.9296353,20.7935389 18.6387097,20.2 C18.7871353,20.154199 18.9414477,20.1302915 19.0967742,20.1290323 C21.8645161,20.1290323 24.2387097,21.7032258 25.4516129,23.9870968 C23.1038772,26.7755297 19.6451638,28.3856611 16,28.3870968 Z",
    id: "Shape",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,17.5483871 C19.1355521,17.5483871 21.6774194,15.0065199 21.6774194,11.8709677 C21.6774194,8.73541561 19.1355521,6.19354839 16,6.19354839 C12.8644479,6.19354839 10.3225806,8.73541561 10.3225806,11.8709677 C10.3225806,15.0065199 12.8644479,17.5483871 16,17.5483871 Z M19.0967742,20.1290323 C18.9414477,20.1302915 18.7871353,20.154199 18.6387097,20.2 C16.9296353,20.7935389 15.0703647,20.7935389 13.3612903,20.2 C13.2128647,20.154199 13.0585523,20.1302915 12.9032258,20.1290323 C10.1354839,20.1290323 7.76129032,21.7032258 6.5483871,23.9870968 C10.94,29.2070968 18.7316129,29.8787097 23.9516129,25.4870968 C24.4935849,25.0309085 24.9954246,24.5290688 25.4516129,23.9870968 C24.2387097,21.7032258 21.8645161,20.1290323 19.0967742,20.1290323 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerIcnTc);
export default __webpack_public_path__ + "static/media/owner-icn-tc.b3e6ff5f0d059b46e06e0c8c6556080c.svg";
export { ForwardRef as ReactComponent };